import React, { useEffect, useRef } from 'react';
import { Toast, ToastMessage } from 'primereact/toast';
import { ToastService } from '@iamsoftware/react-hooks';

export const SafeAppToast = () => {
  const toast = useRef<Toast>(null);
  const pendingMessages = useRef<ToastMessage[]>([]);

  const flushMessages = () => {
    if (!toast.current) return;

    pendingMessages.current.forEach(message => toast.current?.show(message));
    pendingMessages.current = [];
  };

  useEffect(() => {
    flushMessages();

    const subscription = ToastService.getMessage().subscribe((message) => {
      if (!message) return;

      if (toast.current) {
        toast.current.show(message);
      } else {
        pendingMessages.current.push(message);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  return <Toast ref={toast} />;
};
